import React from 'react';
import { FormFieldsData, ModalFormButton } from 'framework/form';
import { ValidationSchema } from 'validation-schema-library';
import { SxProps, Typography } from '@mui/material';
import { useAuthorization } from 'framework/authorization';
import { useListContext } from 'framework/list';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { ResourceData } from 'framework/cache/cache.types';

type UploadDocumentButtonProps = {
  uploadMethod: (data: FormFieldsData) => Promise<any>;
  getValidationSchemaFunc: () => Promise<ValidationSchema>;
  permission: string | string[];
  initialData?: Dictionary<any>;
  children: React.ReactNode;
  title?: React.ReactNode;
  buttonText?: string;
  sxButton?: SxProps;
  getDataFunc?: Nullable<() => Promise<ResourceData>>;
  isHideDefaultButtons?: boolean;
};

const UploadDocumentButton = ({
  uploadMethod,
  getValidationSchemaFunc,
  permission,
  initialData,
  children,
  title,
  buttonText,
  sxButton,
  getDataFunc,
  isHideDefaultButtons = false,
}: UploadDocumentButtonProps) => {
  const { isGranted } = useAuthorization();
  const { reloadData } = useListContext();

  return (
    <ModalFormButton
      isHideDefaultButtons={isHideDefaultButtons}
      isVisible={isGranted(permission)}
      modalSize="sm"
      getDataFunc={getDataFunc}
      formTitle={title ? 'Upload: document' : null}
      label={
        <>
          <Typography variant="subtitle2" sx={sxButton}>
            {buttonText || 'Upload'}
          </Typography>
          <FileUploadIcon sx={{ ml: 0.6, fontSize: 15 }} />
        </>
      }
      submitFormFunc={uploadMethod}
      initialData={initialData}
      afterSubmit={{
        execute: () => {
          if (reloadData) {
            reloadData();
          }
        },
      }}
      getValidationSchemaFunc={getValidationSchemaFunc}
    >
      {children}
    </ModalFormButton>
  );
};

export default UploadDocumentButton;
